/*@flow*/
import { camelize } from 'humps';
import pluralize from 'pluralize';

export default function getFilterName(resourceName: string): any | string {
  if (resourceName === 'Tenant') return 'businesses';
  if (resourceName === 'StreetscapeIssue') return 'issues';
  return camelize(pluralize(resourceName));
}
